module.exports = __webpack_public_path__ + "img/Programs.2cf89614.jpeg";